(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["template--page-quiz"]) return;
  try {
    

    var questionList = [
        {
            key: ["explore_eyewear_style"], 
            question: "Do you have a cool or warm skin tone?", 
            image: "https://cdn.shopify.com/s/files/1/0583/8721/files/quiz-1-level-1.png?v=1696931684"
        },
        {
            key: ["explore_visual_needs"], 
            question: "Do you spend more time at work looking at near objects or distant objects?", 
            image: "https://cdn.shopify.com/s/files/1/0583/8721/files/quiz-2-level-1.png?v=1696931684"
        },
        {
            key: ["cool", "warm"], 
            question: "Do you prefer to blend in or stand out in a crowd?",
            image: "https://cdn.shopify.com/s/files/1/0583/8721/files/quiz-1-level-2.png?v=1696931684"
        },
        {
            key: ["near", "distant"], 
            question: "Are your hobbies mostly indoors or outdoors?",
            image: "https://cdn.shopify.com/s/files/1/0583/8721/files/quiz-2-level-2.png?v=1696931683"
        },
        {
            key: ["blend_in", "stand_out"], 
            question: "What Is Your Face Shape?",
            image: "https://cdn.shopify.com/s/files/1/0583/8721/files/quiz-1-level-3.png?v=1696931684"
        },
        {
            key: ["indoor", "outdoor"], 
            question: "Which vision challenge do you experience the most?",
            image: "https://cdn.shopify.com/s/files/1/0583/8721/files/quiz-2-level-3.png?v=1696931684"
        },
        {
            key: ["cant_focus_near_object", "tired_eyes", "blurry_vission", "cant_focus_near_to_far"], 
            question: "Are you under 40 or over 40?",
            image: "https://cdn.shopify.com/s/files/1/0583/8721/files/quiz-2-level-4.png?v=1696931684"
        },
    ]


    var level0 = [
        {label: "Explore eyewear style", key: "explore_eyewear_style" },
        {label: "Explore visual needs", key: "explore_visual_needs"}
    ];

    var level1 = [
        {label: "Cool", key: "cool", parent_key: ["explore_eyewear_style"]}, 
        {label: "Warm", key: "warm", parent_key: ["explore_eyewear_style"]}, 
        {label: "Near", key: "near", parent_key: ["explore_visual_needs"]}, 
        {label: "Distant", key: "distant", parent_key: ["explore_visual_needs"]}
    ];

    var level2 = [
        {label: "Blend in", key: "blend_in", parent_key: ["cool", "warm"]},
        {label: "Stand out", key: "stand_out", parent_key: ["cool", "warm"]},
        {label: "Indoor", key: "indoor", parent_key: ["near", "distant"]},
        {label: "Outdoor", key: "outdoor", parent_key: ["near", "distant"]},
    ];

    var level3 = [
        {label: "Round", key: "round", parent_key: ["blend_in", "stand_out"]},
        {label: "Oval", key: "oval", parent_key: ["blend_in", "stand_out"]},
        {label: "Square", key: "square", parent_key: ["blend_in", "stand_out"]},
        {label: "Rectangle", key: "rectangle", parent_key: ["blend_in", "stand_out"]},
        {label: "Heart", key: "heart", parent_key: ["blend_in", "stand_out"]},
        {label: "Diamond", key: "diamond", parent_key: ["blend_in", "stand_out"]},
        {label: "Glare/Reflection", key: "glare_reflection", parent_key: ["indoor", "outdoor"]},
        {label: "Can't focus well on near objects", key: "cant_focus_near_object", parent_key: ["indoor", "outdoor"], grand_parent_key: ['near']},
        {label: "Can't focus well from near to far", key: "cant_focus_near_to_far", parent_key: ["indoor"], grand_parent_key: ["distant"]},
        {label: "Tired eyes towards end of day", key: "tired_eyes", parent_key: ["outdoor"], grand_parent_key: ["near"]},
        {label: "Tired eyes towards end of day", key: "tired_eyes", parent_key: ["indoor"]},
        {label: "Blurry vission with >2 computer monitors", key: "blurry_vission", parent_key: ["indoor"], grand_parent_key: ["near"]},
        {label: "Visual discomfort/strong glare outdoors", key: "visual_discomfort", parent_key: ["outdoor"], grand_parent_key: ["distant"]},
        {label: "Lenses are easily scratched/smudged", key: "lenses_scratched", parent_key: ["outdoor"], grand_parent_key: ["distant"]},
    ];

    var level4 = [
        {label: "Under 40", key: "under_40", parent_key: ["cant_focus_near_object", "tired_eyes", "blurry_vission", "cant_focus_near_to_far"]},
        {label: "Above 40", key: "above_40", parent_key: ["cant_focus_near_object", "tired_eyes", "blurry_vission", "cant_focus_near_to_far"]},
    ];

    var withLevel4 = ["cant_focus_near_object", "tired_eyes", "blurry_vission", "cant_focus_near_to_far"];

    var result = [
        {
            key: ["explore_eyewear_style", "cool", "blend_in", "round", ""],
            title: "Rectangular/angular frames are suitable for your face shape as they add contrast to facial structure and distinct lines to create balance.",
            value: "Look out for frames made of metal which are thin and minimalistic."
        },
        {
            key: ["explore_eyewear_style", "cool", "blend_in", "oval", ""],
            title: "Square/rectangular glasses are suitable for your face shape as they add sharper angles for definition and angular contrast.",
            value: "Look out for frames made of metal which are thin and minimalistic."
        },
        {
            key: ["explore_eyewear_style", "cool", "blend_in", "square", ""],
            title: "Round/oval frames are suitable for your face shape as they bring contrast to angular features and soften and balance defined square face lines.",
            value: "Look out for frames made of metal which are thin and minimalistic."
        },
        {
            key: ["explore_eyewear_style", "cool", "blend_in", "rectangle", ""],
            title: "Round/cat-eye frames are suitable for your face shape as they bring contrast to angular features and add width to the top part of the face.",
            value: "Look out for frames made of metal which are thin and minimalistic."
        },
        {
            key: ["explore_eyewear_style", "cool", "blend_in", "heart", ""],
            title: "Rectangular/oval/round frames are suitable for your face shape as they bring balance between forehead and chin and soften angular features.",
            value: "Look out for frames made of metal which are thin and minimalistic."
        },
        {
            key: ["explore_eyewear_style", "cool", "blend_in", "diamond", ""],
            title: "Oval/round frames are suitable for your face shape as they bring soft contrast to defined forehead and chin while balancing out angular features.",
            value: "Look out for frames made of metal which are thin and minimalistic."
        },
        {
            key: ["explore_eyewear_style", "cool", "stand_out", "round", ""],
            title: "Rectangular/angular frames are suitable for your face shape as they add contrast to facial structure and distinct lines to create balance.",
            value: "Look out for frames made of thick plastic, which come in a wide range of colours and patterns."
        },
        {
            key: ["explore_eyewear_style", "cool", "stand_out", "oval", ""],
            title: "Square/rectangular glasses are suitable for your face shape as they add sharper angles for definition and angular contrast.",
            value: "Look out for frames made of thick plastic, which come in a wide range of colours and patterns."
        },
        {
            key: ["explore_eyewear_style", "cool", "stand_out", "square", ""],
            title: "Round/oval frames are suitable for your face shape as they bring contrast to angular features and soften and balance defined square face lines.",
            value: "Look out for frames made of thick plastic, which come in a wide range of colours and patterns."
        },
        {
            key: ["explore_eyewear_style", "cool", "stand_out", "rectangle", ""],
            title: "Round/cat-eye frames are suitable for your face shape as they bring contrast to angular features and add width to the top part of the face.",
            value: "Look out for frames made of thick plastic, which come in a wide range of colours and patterns."
        },
        {
            key: ["explore_eyewear_style", "cool", "stand_out", "oval", ""],
            title: "Square/rectangular glasses are suitable for your face shape as they add sharper angles for definition and angular contrast.",
            value: "Look out for frames made of thick plastic, which come in a wide range of colours and patterns."
        },
        {
            key: ["explore_eyewear_style", "cool", "stand_out", "heart", ""],
            title: "Rectangular/oval/round frames are suitable for your face shape as they bring balance between forehead and chin and soften angular features.",
            value: "Look out for frames made of thick plastic, which come in a wide range of colours and patterns."
        },
        {
            key: ["explore_eyewear_style", "cool", "stand_out", "diamond", ""],
            title: "Oval/round frames are suitable for your face shape as they bring soft contrast to defined forehead and chin while balancing out angular features.",
            value: "Look out for frames made of thick plastic, which come in a wide range of colours and patterns."
        },
        {
            key: ["explore_eyewear_style", "warm", "blend_in", "round", ""],
            title: "Rectangular/angular frames are suitable for your face shape as they add contrast to facial structure and distinct lines to create balance.",
            value: "Look out for frames made of metal which are thin and minimalistic."
        },
        {
            key: ["explore_eyewear_style", "warm", "blend_in", "oval", ""],
            title: "Square/rectangular glasses are suitable for your face shape as they add sharper angles for definition and angular contrast.",
            value: "Look out for frames made of metal which are thin and minimalistic."
        },
        {
            key: ["explore_eyewear_style", "warm", "blend_in", "square", ""],
            title: "Round/oval frames are suitable for your face shape as they bring contrast to angular features and soften and balance defined square face lines.",
            value: "Look out for frames made of metal which are thin and minimalistic."
        },
        {
            key: ["explore_eyewear_style", "warm", "blend_in", "rectangle", ""],
            title: "Round/cat-eye frames are suitable for your face shape as they bring contrast to angular features and add width to the top part of the face.",
            value: "Look out for frames made of metal which are thin and minimalistic."
        },
        {
            key: ["explore_eyewear_style", "warm", "blend_in", "heart", ""],
            title: "Rectangular/oval/round frames are suitable for your face shape as they bring balance between forehead and chin and soften angular features.",
            value: "Look out for frames made of metal which are thin and minimalistic."
        },
        {
            key: ["explore_eyewear_style", "warm", "blend_in", "diamond", ""],
            title: "Oval/round frames are suitable for your face shape as they bring soft contrast to defined forehead and chin while balancing out angular features.",
            value: "Look out for frames made of metal which are thin and minimalistic."
        },
        {
            key: ["explore_eyewear_style", "warm", "stand_out", "round", ""],
            title: "Rectangular/angular frames are suitable for your face shape as they add contrast to facial structure and distinct lines to create balance.",
            value: "Look out for frames made of thick plastic, which come in a wide range of colours and patterns."
        },
        {
            key: ["explore_eyewear_style", "warm", "stand_out", "oval", ""],
            title: "Square/rectangular glasses are suitable for your face shape as they add sharper angles for definition and angular contrast.",
            value: "Look out for frames made of thick plastic, which come in a wide range of colours and patterns."
        },
        {
            key: ["explore_eyewear_style", "warm", "stand_out", "square", ""],
            title: "Round/oval frames are suitable for your face shape as they bring contrast to angular features and soften and balance defined square face lines.",
            value: "Look out for frames made of thick plastic, which come in a wide range of colours and patterns."
        },
        {
            key: ["explore_eyewear_style", "warm", "stand_out", "rectangle", ""],
            title: "Round/cat-eye frames are suitable for your face shape as they bring contrast to angular features and add width to the top part of the face. ",
            value: "Look out for frames made of thick plastic, which come in a wide range of colours and patterns."
        },
        {
            key: ["explore_eyewear_style", "warm", "stand_out", "heart", ""],
            title: "Rectangular/oval/round frames are suitable for your face shape as they bring balance between forehead and chin and soften angular features.",
            value: "Look out for frames made of thick plastic, which come in a wide range of colours and patterns."
        },
        {
            key: ["explore_eyewear_style", "warm", "stand_out", "diamond", ""],
            title: "Oval/round frames are suitable for your face shape as they bring soft contrast to defined forehead and chin while balancing out angular features.",
            value: "Look out for frames made of thick plastic, which come in a wide range of colours and patterns."
        },
        {
            key: ["explore_visual_needs", "near", "indoor", "glare_reflection", ""],
            title: "Your recommended lenses are Crizal Prevencia.",
            value: "You need lenses that reduce glare, protect against UV and filter blue-violet light."
        },
        {
            key: ["explore_visual_needs", "near", "indoor", "cant_focus_near_object", "above_40"],
            title: "Your recommended lenses are Varilux®.",
            value: "You need lenses that provide sharp vision at every distance allowing you to see near, far and intermediate distances seamlessly with ease."
        },
        {
            key: ["explore_visual_needs", "near", "indoor", "cant_focus_near_object", "under_40"],
            title: "Your recommended lenses are Crizal® Eyezen.",
            value: "You need lenses with blue violet light filtering that help relax eyes in front of screens for clear and comfortable vision regardless of the size of the screens and the distance from which you look at them."
        },
        {
            key: ["explore_visual_needs", "near", "indoor", "tired_eyes", "above_40"],
            title: "Your recommended lenses are Varilux®.",
            value: "You need lenses that provide sharp vision at every distance allowing you to see near, far and intermediate distances seamlessly with ease."
        },
        {
            key: ["explore_visual_needs", "near", "indoor", "tired_eyes", "under_40"],
            title: "Your recommended lenses are Crizal® Eyezen.",
            value: "You need lenses with blue violet light filtering that help relax eyes in front of screens for clear and comfortable vision regardless of the size of the screens and the distance from which you look at them."
        },
        {
            key: ["explore_visual_needs", "near", "indoor", "blurry_vission", "above_40"],
            title: "Your recommended lenses are Varilux® Digitime.",
            value: "You need lenses that help relax eyes for reading small smartphone characters, maintain a natural posture at the computer, and offer large, comfortable fields of vision that fully cover the screen."
        },
        {
            key: ["explore_visual_needs", "near", "indoor", "blurry_vission", "under_40"],
            title: "Your recommended lenses are Crizal® Eyezen.",
            value: "You need lenses with blue violet light filtering that help relax eyes in front of screens for clear and comfortable vision regardless of the size of the screens and the distance from which you look at them."
        },
        {
            key: ["explore_visual_needs", "near", "outdoor", "glare_reflection", ""],
            title: "Your recommended lenses are Crizal Transitions® Signature.",
            value: "You need lenses that automatically adapt to changing light conditions from indoors to outdoors with best adaptive glare protection."
        },
        {
            key: ["explore_visual_needs", "near", "outdoor", "cant_focus_near_object", "above_40"],
            title: "Your recommended lenses are Varilux® with Transitions®.",
            value: "You need lenses that provide sharp vision at every distance allowing you to see near, far and intermediate distances seamlessly with ease.These lenses should also adapt to changing light conditions during your outdoor hobbies."
        },
        {
            key: ["explore_visual_needs", "near", "outdoor", "cant_focus_near_object", "under_40"],
            title: "Your recommended lenses are Crizal® Eyezen with Transitions®.",
            value: "You need lenses with blue violet light filtering that help relax eyes in front of screens for clear and comfortable vision regardless of the size of the screens and the distance from which you look at them. These lenses should also adapt to changing light conditions during your outdoor hobbies."
        },
        {
            key: ["explore_visual_needs", "near", "outdoor", "tired_eyes", "above_40"],
            title: "Your recommended lenses are Varilux® with Transitions®.",
            value: "You need lenses that provide sharp vision at every distance allowing you to see near, far and intermediate distances seamlessly with ease.These lenses should also adapt to changing light conditions during your outdoor hobbies."
        },
        {
            key: ["explore_visual_needs", "near", "outdoor", "tired_eyes", "under_40"],
            title: "Your recommended lenses are Crizal® Eyezen with Transitions®.",
            value: "You need lenses with blue violet light filtering that help relax eyes in front of screens for clear and comfortable vision regardless of the size of the screens and the distance from which you look at them. These lenses should also adapt to changing light conditions during your outdoor hobbies."
        },
        {
            key: ["explore_visual_needs", "distant", "indoor", "glare_reflection", ""],
            title: "Your recommended lenses are Crizal® Sapphire™ HR.",
            value: "You need lenses that reduce disturbing reflections from the front and back of the lenses, ensuring clear and sharp vision all day long."
        },
        {
            key: ["explore_visual_needs", "distant", "indoor", "cant_focus_near_to_far", "above_40"],
            title: "Your recommended lenses are Varilux®.",
            value: "You need lenses that provide sharp vision at every distance allowing you to see near, far and intermediate distances seamlessly with ease."
        },
        {
            key: ["explore_visual_needs", "distant", "indoor", "cant_focus_near_to_far", "under_40"],
            title: "Your recommended lenses are Crizal® Eyezen.",
            value: "You need lenses with blue violet light filtering that help relax eyes in front of screens for clear and comfortable vision regardless of the size of the screens and the distance from which you look at them."
        },
        {
            key: ["explore_visual_needs", "distant", "indoor", "tired_eyes", "above_40"],
            title: "Your recommended lenses are Varilux®.",
            value: "You need lenses that provide sharp vision at every distance allowing you to see near, far and intermediate distances seamlessly with ease."
        },
        {
            key: ["explore_visual_needs", "distant", "indoor", "tired_eyes", "under_40"],
            title: "Your recommended lenses are Crizal® Eyezen.",
            value: "You need lenses with blue violet light filtering that help relax eyes in front of screens for clear and comfortable vision regardless of the size of the screens and the distance from which you look at them."
        },
        {
            key: ["explore_visual_needs", "distant", "outdoor", "glare_reflection", ""],
            title: "Your recommended lenses are Crizal Transitions® Signature with Crizal Sapphire™.",
            value: "You need lenses that automatically adapt to changing light conditions from indoors to outdoors with best adaptive glare protection. These lenses should also reduce disturbing reflections."
        },
        {
            key: ["explore_visual_needs", "distant", "outdoor", "visual_discomfort", ""],
            title: "Your recommended lenses are Xperio® polarised sun lenses.",
            value: "You need lenses that eliminate blinding reflected glare, to offer you greater visual comfort while enhancing colour perception."
        },
        {
            key: ["explore_visual_needs", "distant", "outdoor", "lenses_scratched", ""],
            title: "Your recommended lenses are Crizal® Rock™.",
            value: "You need lenses that have enduring scratch resistance against everyday handling such as wiping or dropping your eyewear and are designed to be the best solution against both scratches and smudges."
        },
    ]

    var quizStep = 0;
    var quizResult = [];
    var nextLevelItem = level1;

    function handleQuizSelection(id) {
        quizResult.push(id);
    }

    function hideBackButton() {
        $("#quiz-back-button").hide();
    }

    function showBackButton(){
        $("#quiz-back-button").show();
    }

    function handleQuizNext() {
        quizStep++;
    }

    $("#quiz-back-button").on("click", async function(){
        await quizStep--;

        quizResult.pop();
        $(`#quiz-result`).removeClass('quiz-show');
        

        if(quizStep === 0) {
            hideBackButton();
        }

        switch (quizStep) {
            case 1:
                nextLevelItem = level1;        
                break;
            case 2:
                nextLevelItem = level2;
                break;
            case 3:
                nextLevelItem = level3;
                break;
        
            default:
                break;
        }

        emptyDynamicValue();


        if(quizStep !== 0) {

            questionList.forEach(list => {
                if(list.key.includes(quizResult[quizStep - 1])){
                    $('#quiz-content-number').append(`${quizStep + 1} of 4`);
                    $('#quiz-content-question').append(list.question);
                    $('#quiz-content-image').append(`<img src="${list.image}" width="100" height="300" alt="quiz-banner-image" loading="lazy"></>`);
                }
            });

            nextLevelItem.forEach(item => {
                if(item.parent_key.includes(quizResult[quizStep - 1])) {
                    var quiz_button = $(`<button class="quiz-content-button" id="${item.key}">${item.label}</button>`);
                    quiz_button.click(function(){
                        handleQuizButton(item.key);
                    });
                    $(`#quiz-content-item`).append(quiz_button);
                }
            });
        } else {
            handleDefaultQuestion();
        }
    });

    function handleQuizButton(id){
        switch (quizStep) {
            case 0:
                nextLevelItem = level1;        
                break;
            case 1:
                nextLevelItem = level2;        
                break;
            case 2:
                nextLevelItem = level3;
                break;
            case 3:
                nextLevelItem = level4;
                break;
        
            default:
                break;
        }

        handleQuizSelection(id);
        handleNextQuizQustion();
        handleQuizNext();
    }

    function handleResult(){
        console.log("result pages...");
        console.log("quiz result: ", quizResult);

        hideBackButton();

        if(quizStep === 3) {
            console.log("additional empty level 4");
            handleQuizSelection("");
            quizStep = 4;
        }

        $(`#quiz-content`).removeClass("quiz-show");
        $(`#quiz-result`).addClass('quiz-show');

        var findResult = result.find((item) => {
            return item.key.every(val => quizResult.includes(val));
        });

        $("#quiz-content-result-title").append(`${findResult?.title}`);
        $("#quiz-content-result-description").append(`<div>${findResult?.value}</div>`);

        if(quizResult[0] === "explore_eyewear_style") {
          switch (quizResult[3]) {
            case "round":
              $('#quiz-content-result-image').attr("src", "https://cdn.shopify.com/s/files/1/0583/8721/files/shape_round.png?v=1698821727");
              break;

            case "oval":
              $('#quiz-content-result-image').attr("src", "https://cdn.shopify.com/s/files/1/0583/8721/files/shape_oval.png?v=1698821726");
              break;

            case "square":
              $('#quiz-content-result-image').attr("src", "https://cdn.shopify.com/s/files/1/0583/8721/files/shape_square.png?v=1698821726");
              break;

            case "rectangle":
              $('#quiz-content-result-image').attr("src", "https://cdn.shopify.com/s/files/1/0583/8721/files/shape_rectangle.png?v=1698821726");
              break;

            case "heart":
              $('#quiz-content-result-image').attr("src", "https://cdn.shopify.com/s/files/1/0583/8721/files/shape_heart.png?v=1698821727");
              break;

            case "diamond":
              $('#quiz-content-result-image').attr("src", "https://cdn.shopify.com/s/files/1/0583/8721/files/shape_diamond.png?v=1698821726");
              break;
          
            default:
              $('#quiz-content-result-image').attr("src", "https://cdn.shopify.com/s/files/1/0583/8721/files/quiz-1-result.png?v=1696931683");
              break;
          }
        }

        if(quizResult[0] === "explore_visual_needs") {
            $('#quiz-content-result-image').attr("src", "https://cdn.shopify.com/s/files/1/0583/8721/files/20231031-162234.png?v=1698740588");
        }
    }

    function emptyDynamicValue(){
        $(`#quiz-content-item`).empty();
        $('#quiz-content-number').empty();
        $('#quiz-content-question').empty();
        $('#quiz-content-image').empty();
    }

    function handleNextQuizQustion() {
        emptyDynamicValue();

        questionList.forEach(list => {
            if(list.key.includes(quizResult[quizStep])){
                $('#quiz-content-number').append(`${quizStep + 2} of 4`);
                $('#quiz-content-question').append(list.question);
                $('#quiz-content-image').append(`<img src="${list.image}" width="100" height="300" alt="quiz-banner-image" loading="lazy"></>`);
            }
        });


        nextLevelItem.forEach(item => {
            console.log(item.grand_parent_key);
            if(item.parent_key.includes(quizResult[quizStep])) {
                if (item.grand_parent_key && !item.grand_parent_key.includes(quizResult[quizStep - 1])) {
                    console.log("have a grand parent...")
                    return;
                }

                var quiz_button = $(`<button class="quiz-content-button" id="${item.key}">${item.label}</button>`);
                quiz_button.click(function(){
                    if(quizStep >= 4 || (quizStep === 3 && !withLevel4.includes(item.key))) {
                        console.log("go to result...")
                        handleQuizSelection(item.key);
                        handleResult();
                    } else {
                        console.log(`go to next quiz ${quizStep + 1}...`);
                        handleQuizButton(item.key);
                    }
                });
                $(`#quiz-content-item`).append(quiz_button);
            }
        });
    }

    function handleDefaultQuestion() {
        level0.forEach(item => {
            var quiz_button = $(`<button class="quiz-content-button" id="${item.key}">${item.label}</button>`);
            quiz_button.click(function(){
                handleQuizSelection(item.key);
                handleNextQuizQustion(level1);
                handleQuizNext();
                showBackButton();
            });
            $('#quiz-content-item').append(quiz_button);
        });

        $('#quiz-content-number').append("1 of 4");
        $('#quiz-content-question').append('Do you want to explore new eyewear styles or new lenses for changing visual needs?');
        $('#quiz-content-image').append(`<img src="https://cdn.shopify.com/s/files/1/0583/8721/files/Rectangle_10.png?v=1696919184" width="100" height="300" alt="quiz-banner-image" loading="lazy"></>`);
    }

    function handleBookAppointment() {
        $(`#quiz-result`).removeClass("quiz-show");
        $(`#quiz-book`).addClass('quiz-show');

        $("#quiz-content-book-title").append(`Complete the form below to unlock a fantastic <span>$50 Spectacle Hut</span> eyewear voucher!`);
        $("#quiz-content-book-description").append(``); 


        $('#quiz-content-book-image').attr("src", "https://cdn.shopify.com/s/files/1/0583/8721/files/20231031-170135.png?v=1698742918");
        
        $("#mailchimpCnt").css("display", "block")
    }

    $("#quiz-content-book-next").on("click", function(){
        console.log("redirect to appointment book...");
        window.location.href = "/pages/appointment-booking";
    });
    
    $("#quiz-content-result-next").on("click", function(){
        handleBookAppointment();
    });

    hideBackButton();
    handleDefaultQuestion();

    async function crmIntegration(){
      console.log("start crm integration...")
      const email = $('#mce-EMAIL').val();
      const emailEncode = encodeURIComponent(email);

      const firstName = $("#mce-FNAME").val();
		  const firstNameEncode = encodeURIComponent(firstName);

      const salesOrganization = encodeURIComponent("SGE1");
		  const siteName = encodeURIComponent("Spectacle_Hut_Sg_Website");
		  const distributionChannel = encodeURIComponent("S9");
		  const companyCode = encodeURIComponent("9999");
		  const sourceSite = encodeURIComponent("X-S9SG")
      const maprSetting = {
			  "url" : `https://onyxisland.com/spechut-api/appointment.php?email=${emailEncode}&sales_organization=${salesOrganization}&site_name=${siteName}&distribution_channel=${distributionChannel}&company_code=${companyCode}&source_site=${sourceSite}&event_type=quiz`,
			  "method" : "GET",
			  "timeout" : 6000
		  }; 

      const responsysLocale="en_US";
		  const responsysCampaign="SPH_NewSubscribe_Quiz_012024";
		  const responsysBrand="SpectacleHut";
      const responsysSetting = {
        "url": `https://onyxisland.com/spechut-api/responsys.php?contact_id=${emailEncode}&subscriber_key=${emailEncode}&locale=${responsysLocale}&campaign=${responsysCampaign}&brand=${responsysBrand}&first_name=${firstNameEncode}`,
			  "method": "GET",
			  "timeout": 6000
      }

      const fetchIntegration = async ({setting}) => {
        const result = await $.ajax(setting).done(
          (response) => {
            console.log("Success fetch integration ...")
            return true;
          }
        ).fail(
          () => {
            console.log("Something wrong on fetch integration ...")
            return false;
          }
        );

        return result;
      }

      const [maprResult, responsysResult] = await Promise.all([
        fetchIntegration({setting: maprSetting}),
        fetchIntegration({setting: responsysSetting}),
      ])

      console.log(maprResult);
      console.log(responsysResult);

      $("#submitMe").click();
    }

    $("#mc-embedded-subscribe").on("click", async () => {
      await crmIntegration();
    })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["template--page-store-locator"]) return;
  try {
    
  $('#store-options').on('change', function() {
    var selected = $(this).find('option:selected');
    var href = selected.data('href');
    xScrollTo({targetSelector : href});
  });

  function xScrollTo({ targetSelector, delay = 0, y = 0, navigationSelector = "header.site-header", callback}) {
    
    const targetElement = document.querySelector('#'+targetSelector);
    const navigation = document.querySelector(navigationSelector);
    var mobileWidth = document.querySelector("nav.nav-bar.mobile-nav-bar-wrapper").getBoundingClientRect().height;
    let navigationOffset;
    console.log(mobileWidth);

    if(mobileWidth <= 425 && mobileWidth > 0 ){
      y = 80;
      console.log(y);
    }

    setTimeout(() => {
      navigationOffset = navigation.getBoundingClientRect().height;
      const elementPosition = targetElement.getBoundingClientRect().top;
      const offsetPosition = elementPosition - (navigationOffset + y) + $(window).scrollTop();

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });

      if (typeof callback == "function") {
        const onScroll = function () {
          console.log(window.pageYOffset.toFixed())
          if (window.pageYOffset.toFixed() === offsetPosition.toFixed() || $(window).scrollTop() + $(window).height() == $(document).height()) {
            window.removeEventListener("scroll", onScroll);
            callback(targetElement);
          }
        };

        window.addEventListener("scroll", onScroll);
        onScroll();
      }
    }, delay);
  }

  } catch(e) { console.error(e); }
})();
})();
